import { formatInTimeZone, toZonedTime } from "date-fns-tz";
import { format, parseISO } from "date-fns";

export const IST = "Asia/Kolkata";
export const MORNING_FINALIZE_HOUR = 7;

export function nowInIST(): Date {
  return toZonedTime(new Date(), IST);
}

export function todayIST(): string {
  return formatInTimeZone(new Date(), IST, "yyyy-MM-dd");
}

export function formatIST(date: Date | string, pattern = "dd MMM yyyy, h:mm a"): string {
  const d = typeof date === "string" ? parseISO(date) : date;
  return formatInTimeZone(d, IST, pattern);
}

export function formatTimeIST(date: Date | string): string {
  return formatIST(date, "h:mm a");
}

export function isBeforeMorningFinalize(date = nowInIST()): boolean {
  const hour = Number(formatInTimeZone(date, IST, "H"));
  return hour < MORNING_FINALIZE_HOUR;
}

export function formatDateDisplay(dateStr: string): string {
  return format(parseISO(dateStr), "EEE, d MMM yyyy");
}

export function formatNoticeDateList(dates: string[]): string {
  if (dates.length === 0) return "";
  if (dates.length === 1) return formatDateDisplay(dates[0]);
  return dates.map((d) => format(parseISO(d), "d MMM yyyy")).join(", ");
}
